module.exports = __webpack_public_path__ + "static/media/integrated-multichannel.2f8fa6bc.svg";